angular.
module("digiexam.exam", [
	"digiexam.gradingMatrix",
	"digiexam.services",
	"dx.webapp.exam",
	"dx.webapp.question",
	"dx.webapp.navigation",
	"dx.webapp.session",
	"dx.webapp.student",

	"dx.ui.dataTypes.grading",
]);
